import React from 'react';
import styled from '@emotion/styled';
import { ContentWrapper, breakpoints, headerHeight } from 'gatsby-theme-apollo';
import CrumbRenderer from '../layout/crumbs';
import { Flex } from '../layout/flex';
import ShareBar from '../social/share-bar';

const InnerWrapper = styled.div(props => ({
  maxWidth: '1080px',
  width: `100%`,
  margin: `auto auto`,
  padding: '0px 0px',
}));

const MainHeading = styled.h1(props => ({
  fontFamily: props.theme.fontFamily || 'Helvetica',
  textShadow: props.theme.textShadow,
  fontWeight: props.theme.fontWeight,
  textTransform: props.theme.textTransform || 'uppercase',
  [breakpoints.md]: {
    display: props.hideMobile ? 'none' : 'inline-block'
  },

  lineHeight: 1,
  textAlign: `center`,
  backgroundColor: `transparent`,
  borderBottomLeftRadius: `${props.theme.radius}`,
  borderBottomRightRadius: `${props.theme.radius}`,
  ':after': {
    height: `1px`,
    backgroundColor: props.theme.primaryAccent || props.theme.primary,
    width: `auto`,
    margin: `-4px auto`
  }
}));

const MainHeadingRoot = styled.div(props => ({
  fontFamily: props.theme.fontFamily || 'Helvetica',
  textShadow: props.theme.textShadow,
  fontWeight: props.theme.fontWeight,
  textTransform: props.theme.textTransform || 'uppercase',
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
  flexWrap: `wrap`,
  position: `relative`
}));

const PageHeadingContainer = styled.div({
  position: `relative`,
  padding: `0px 20px`,
  alignItems: `center`,
  justifyContent: `center`,
  display: `flex`,
  [breakpoints.sm]: {
    width: `100%`
  }
});

const MainHeadingContainer = ({
  crumbs,
  baseCrumbH1,
  header,
  largeHeadline,
  headerSolidBackground,
  hideMobile,
  logoURI
}) => {
  return (
    <MainHeadingRoot>
      <CrumbRenderer crumbs={crumbs} baseCrumbH1={baseCrumbH1} />
      <PageHeadingContainer style={{ position: `relative`, padding: `0px 20px` }}>
        {header && (
          <>
            <MainHeading
              hideMobile={hideMobile}
              largeHeadline={largeHeadline}
              solidBG={headerSolidBackground}
            >
              {header}
            </MainHeading>
          </>
        )}
        {logoURI && (
          <img
            height={headerHeight}
            style={{ margin: '0px 0px' }}
            src={logoURI}
            alt="GamerHub Logo"
          />
        )}
      </PageHeadingContainer>
    </MainHeadingRoot>
  );
};

const Content = ({
  header,
  logoURI,
  children,
  pop,
  hideMobile,
  noHeader,
  largeHeadline,
  headerSolidBackground,
  crumbs,
  baseCrumbH1,
  showTopShareBar
}) => {
  return (
    <ContentWrapper noHeaderMargin={noHeader} id="outer-content-wrapper">
      <InnerWrapper pop={pop}>
        <MainHeadingContainer
          crumbs={crumbs}
          baseCrumbH1={baseCrumbH1}
          header={header}
          logoURI={logoURI}
          hideMobile={hideMobile}
          largeHeadline={largeHeadline}
          headerSolidBackground={headerSolidBackground}
        />
        {showTopShareBar && (
          <Flex style={{ width: '100%' }}>
            <ShareBar location="top" />
          </Flex>
        )}
        {children}
      </InnerWrapper>
    </ContentWrapper>
  );
};

export default Content;
